import React from "react";
import { Empty } from "antd";

const EmptyState = ({ description = "No issues found" }) => (
  <Empty description={description} image={Empty.PRESENTED_IMAGE_SIMPLE} />
);

export default EmptyState;
